import { render, staticRenderFns } from "./PopupRE.vue?vue&type=template&id=29213a8f&lang=pug"
import script from "./PopupRE.vue?vue&type=script&lang=js"
export * from "./PopupRE.vue?vue&type=script&lang=js"
import style0 from "./PopupRE.vue?vue&type=style&index=0&id=29213a8f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports